var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
class StockAlert extends HTMLElement {
  constructor() {
    super();
    __publicField(this, "isValidEmail", (value) => {
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(value).toLowerCase());
    });
    this.initAlertForm = this.initAlertForm.bind(this);
    this.sendKlaviyoForm = this.sendKlaviyoForm.bind(this);
    this.isValidEmail = this.isValidEmail.bind(this);
  }
  connectedCallback() {
    this.alertForm = this.querySelector(".js-stock-alert-form");
    this.alertBtn = this.querySelector(".js-stock-alert-btn");
    this.mobileBreakpoint = 1024;
    this.isMobile = window.matchMedia(`(max-width: ${this.mobileBreakpoint}px)`).matches;
    this.alertBtn.addEventListener("click", () => {
      this.alertBtn.classList.add("invisible");
      this.alertForm.classList.remove("hidden");
      this.initAlertForm();
    });
  }
  initAlertForm() {
    this.alertFormBtn = this.querySelector(".js-form-alert-submit");
    this.alertFormInput = this.querySelector(".js-form-alert-input");
    this.alertFormInput.focus();
    this.alertFormInput.addEventListener("keyup", (e) => {
      if (e.key === "Enter") {
        this.alertFormBtn.click();
      }
    });
    this.alertFormBtn.addEventListener("click", this.sendKlaviyoForm);
  }
  async sendKlaviyoForm(e) {
    e.preventDefault();
    const email = this.alertFormInput.value;
    if (!this.isValidEmail(email)) {
      document.querySelector(".js-email-error").classList.remove("hidden");
      return;
    }
    const KLAVIYO_URL = "https://a.klaviyo.com/onsite/components/back-in-stock/subscribe";
    const variantId = this.dataset.productId;
    const klaviyoApiKey = this.dataset.klaviyoKey;
    if (!variantId || !email || !klaviyoApiKey) {
      return;
    }
    const klaviyo_data = {
      a: klaviyoApiKey,
      platform: "shopify",
      variant: variantId,
      email
    };
    const headers = {
      accept: "application/json, text/plain, */*",
      "content-type": "application/x-www-form-urlencoded;charset=UTF-8"
    };
    const body = new URLSearchParams(klaviyo_data);
    fetch(KLAVIYO_URL, {
      headers,
      body,
      method: "POST"
    }).then((response) => {
      this.alertFormBtn.classList.add("button--checked");
      this.alertFormBtn.querySelector(".js-form-alert-send").classList.add("hidden");
      this.alertFormBtn.querySelector(".js-form-alert-sent").classList.remove("hidden");
      this.alertFormBtn.removeEventListener("click", this.sendKlaviyoForm);
    }).catch((error) => {
      this.alertFormBtn.classList.add("button--checked");
      this.alertFormBtn.querySelector(".js-form-alert-send").classList.add("hidden");
      this.alertFormBtn.querySelector(".js-form-alert-sent").classList.remove("hidden");
      this.alertFormBtn.removeEventListener("click", this.sendKlaviyoForm);
    });
  }
}
if (customElements.get("w3-stock-alert") === void 0) {
  customElements.define("w3-stock-alert", StockAlert);
}
